// extracted by mini-css-extract-plugin
export default {"status":"ErrorPage_status__4KG6m","message":"ErrorPage_message__A2hhH"};